import getOrderFileuri from '../../../Services/getOrderFileUri';

export default () => async (dispatch) => {
  
  dispatch(getOrderFileuri());

}